import { create } from 'zustand'

type EncounterLockStore = {
  isEncounterReadOnly: boolean
  setEncounterReadOnly: (value: boolean) => void
}

export const useEncounterLockStore = create<EncounterLockStore>(set => ({
  isEncounterReadOnly: false,
  setEncounterReadOnly: value => set({ isEncounterReadOnly: value })
}))
